/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} In_Escrow_HoldInputs */

const en_in_escrow_hold = /** @type {(inputs: In_Escrow_HoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In Escrow Hold`)
};

const es_in_escrow_hold = /** @type {(inputs: In_Escrow_HoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retenido en custodia`)
};

const fr_in_escrow_hold = /** @type {(inputs: In_Escrow_HoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En attente (Entiercement)`)
};

const de_in_escrow_hold = /** @type {(inputs: In_Escrow_HoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In Treuhandverwaltung`)
};

const ja_in_escrow_hold = /** @type {(inputs: In_Escrow_HoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`エスクロー保留中`)
};

const zh_in_escrow_hold = /** @type {(inputs: In_Escrow_HoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`担保冻结中金额`)
};

const ar_in_escrow_hold = /** @type {(inputs: In_Escrow_HoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`محتجز في الضمان`)
};

const id_in_escrow_hold = /** @type {(inputs: In_Escrow_HoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dalam Penahanan Escrow`)
};

const it_in_escrow_hold = /** @type {(inputs: In_Escrow_HoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fondi Bloccati in Escrow`)
};

const ru_in_escrow_hold = /** @type {(inputs: In_Escrow_HoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Заморожено в эскроу`)
};

const pt_in_escrow_hold = /** @type {(inputs: In_Escrow_HoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retido em Escrow`)
};

const ko_in_escrow_hold = /** @type {(inputs: In_Escrow_HoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`에스크로 보류 중`)
};

/**
* | output |
* | --- |
* | "In Escrow Hold" |
*
* @param {In_Escrow_HoldInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const in_escrow_hold = /** @type {((inputs?: In_Escrow_HoldInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<In_Escrow_HoldInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_in_escrow_hold(inputs)
	if (locale === "es") return es_in_escrow_hold(inputs)
	if (locale === "fr") return fr_in_escrow_hold(inputs)
	if (locale === "de") return de_in_escrow_hold(inputs)
	if (locale === "ja") return ja_in_escrow_hold(inputs)
	if (locale === "zh") return zh_in_escrow_hold(inputs)
	if (locale === "ar") return ar_in_escrow_hold(inputs)
	if (locale === "id") return id_in_escrow_hold(inputs)
	if (locale === "it") return it_in_escrow_hold(inputs)
	if (locale === "ru") return ru_in_escrow_hold(inputs)
	if (locale === "pt") return pt_in_escrow_hold(inputs)
	return ko_in_escrow_hold(inputs)
});